import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { fetchFileContents } from "../APIs/githubApi";
import { useContext, useEffect } from "react";
import RepoContext from "../context/Repos";

export default function FileTreeView({ fileTree, repoName }) {
  const {
    OutputRepoCreds,
    InputRepoCreds,
    setCurrInputContent,
    setCurrOutputContent,
    multiSelect,
    selectedFiles,
    setSelectedFiles,
  } = useContext(RepoContext);

  const handleToggle = (node,e) => {
    console.log("previous selected file",selectedFiles);
    if(e.target.checked){
      //insert the element in the array
      if(selectedFiles){
        let newSelectedFiles=[...selectedFiles];
        newSelectedFiles.push(node);
        setSelectedFiles(()=>[...newSelectedFiles]);
      }else{
        let newSelectedFiles=[];
        newSelectedFiles.push(node);
        setSelectedFiles(()=>[...newSelectedFiles]);
      }
    }else{
      //pull the element from the array
      let newSelectedFiles = selectedFiles.filter((element) => {
        return element.url!==node.url;
      });
      setSelectedFiles(()=>[...newSelectedFiles]);
    }
   
  };
  
  useEffect(() => {
    console.log("Selected files : ", selectedFiles);
  },[selectedFiles]);

  const renderTree = (nodes) => (
    <TreeItem
      key={nodes.id + nodes.type}
      nodeId={nodes.name + nodes.id}
      //label={nodes.name}
      label={
        <div>
          {nodes.type==="file"&&multiSelect && (
            <input
              type="checkbox"
              checked={nodes.checked}
              onChange={(e) => handleToggle(nodes,e)}
            />
          )}
          {nodes.name}
        </div>
      }
      onClick={() => {
        //here we have to call the github api to fetch the file contents and dispatch a function that provides new content to be read on the code editor
        if (nodes.type === "file") {
          if (nodes.patType === "output") {
            fetchFileContents(OutputRepoCreds.patToken, nodes.url).then(
              (data) => {
                //change this from local storage to a global state so that Whenever it changes the codeEditor section re-renders.
                //localStorage.setItem("currOutputFileContent", data);
                setCurrOutputContent({ ...data });
              }
            );
          } else {
            fetchFileContents(InputRepoCreds.patToken, nodes.url).then(
              (data) => {
                //localStorage.setItem("currInputFileContent", data);
                setCurrInputContent({ ...data });
              }
            );
          }
        }
      }}
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );
  console.log("Inside filetreeview", repoName);
  const newFileTree = {
    name: repoName,
    children: fileTree,
  };
  return (
    <>
      <TreeView
        aria-label="rich object"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ height: 110, flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
      >
        {renderTree(newFileTree)}
      </TreeView>
    </>
  );
}
